module.exports = __webpack_public_path__ + "static/media/romi_rain.669f43d3.png";